import { z } from 'zod'

const TRAILING_SLASHES_REGEX = /\/+$/

const apiEndpointSchema = z
	.string()
	.default('')
	.refine((value) => value === '' || isHttpUrl(value), {
		message:
			'VITE_API_ENDPOINT must be empty or an absolute http(s) URL origin. Use VITE_API_PROXY_TARGET for local /api proxy setups.'
	})
	.transform((value) => value.replace(TRAILING_SLASHES_REGEX, ''))

export const envVars = z
	.object({
		VITE_API_ENDPOINT: apiEndpointSchema,
		VITE_SENTRY_DSN: z.union([z.url(), z.literal('')]).optional(),
		VITE_SSR_AUTH_COOKIE_NAMES: z.string().optional(),
		VITE_SSR_AUTH_COOKIE_PREFIXES: z.string().optional()
	})
	.parse(import.meta.env)

function isHttpUrl(value: string) {
	try {
		const url = new URL(value)
		return (
			(url.protocol === 'http:' || url.protocol === 'https:') &&
			url.pathname === '/' &&
			!url.search &&
			!url.hash
		)
	} catch {
		return false
	}
}
